export default __webpack_public_path__ + "static/media/Sapling Staking.facefbe7.png";